import { defineTracker, getCookie, parseEncodedZuid } from '@zg-rentals/rentals-analytics';
import { callComscoreApi } from './api';
import {
  BEACON_EVENT,
  COMSCORE_IDS,
  COMSCORE_KEYWORD,
  PAGEVIEW_API_BY_HOSTNAME,
  PAGEVIEW_CANDIDATE,
} from './constants';
import { getComscoreParams, isZillowProd, parseGuid } from './utils';

export const tracker = defineTracker((_, instrument) => {
  // not pretty but functional and allows us to use these functions within script.ts
  const params = getComscoreParams({
    comscoreId: isZillowProd() ? COMSCORE_IDS.prod : COMSCORE_IDS.dev,
    parsedGuid: parseGuid(getCookie('zguid')),
    parsedEncodedZuid: parseEncodedZuid(getCookie('zjs_user_id')),
    keyword: COMSCORE_KEYWORD,
  });

  if (
    'COMSCORE' in window &&
    typeof window.COMSCORE === 'object' &&
    window.COMSCORE !== null &&
    'beacon' in window.COMSCORE &&
    typeof window.COMSCORE.beacon === 'function'
  ) {
    window.COMSCORE.beacon(params);
    instrument(BEACON_EVENT);

    const pageviewApi = PAGEVIEW_API_BY_HOSTNAME[window.location.hostname];
    if (pageviewApi) {
      callComscoreApi(pageviewApi, () => instrument(PAGEVIEW_CANDIDATE));
    }
  } else {
    // initialize queue if it doesn't exist (e.g., DataGrail hasn't converted script yet)
    if (!('_comscore' in window) || !Array.isArray(window._comscore)) {
      // @ts-ignore - avoid declaring global types that leak into consumers
      window._comscore = [];
    }
    // @ts-ignore - avoid declaring global types that leak into consumers
    window._comscore.push(params);
  }
});
